import { useFragmentsViewCapture } from '@app/modules/fragments/hooks/useFragmentsViewCapture';
import { buildLoggerStreamUrl } from '@app/modules/logger/screens/stream/helpers/build-logger-stream-url';
import { DateTimeStr, toTimestamp } from '@mi-front/core';
import HighlightAltIcon from '@mui/icons-material/HighlightAlt';
import { IconButton, Tooltip } from '@mui/material';
import { defineMessage, useIntl } from 'react-intl';
import { Link as RouterLink } from 'react-router-dom';

const goToStreamWithSelectionMessage = defineMessage({
  id: 'fragments.view.metadata.goToStreamWithSelection',
  defaultMessage: 'Seleccionar fragmento en Logger',
});

type FragmentGoToStreamWithSelectionActionProps = {
  stationSlug: string;
  fragmentFrom: DateTimeStr;
  fragmentTo: DateTimeStr;
};

/**
 * Action button that opens the logger stream with the whole fragment selected.
 */
export function FragmentGoToStreamWithSelectionAction({
  stationSlug,
  fragmentFrom,
  fragmentTo,
}: FragmentGoToStreamWithSelectionActionProps) {
  const { $t } = useIntl();
  const fragmentsCapture = useFragmentsViewCapture();
  const selectionFrom = toTimestamp(fragmentFrom);
  const selectionTo = toTimestamp(fragmentTo);
  const loggerStreamUrl = buildLoggerStreamUrl(stationSlug, {
    selection: { from: selectionFrom, to: selectionTo },
  });
  const handleClick = () => {
    fragmentsCapture.goToStreamWithSelection({
      stationSlug,
      fragmentFrom,
      fragmentTo,
    });
  };

  return (
    <Tooltip title={$t(goToStreamWithSelectionMessage)} placement="top">
      <IconButton
        component={RouterLink}
        to={loggerStreamUrl}
        onClick={handleClick}
        size="small"
        sx={{ color: 'text.secondary' }}
      >
        <HighlightAltIcon fontSize="small" />
      </IconButton>
    </Tooltip>
  );
}
